import React, { PureComponent } from "react";
import {
  Link,
  useHistory
} from "react-router-dom";

import { Icon, Menu } from "../../components";

import style from "./Header.module.scss";

import Cookies from "js-cookie";
import { useSelector} from 'react-redux';
import useLocale from '../../hooks/useLocale';
import { normalizeMedia } from '../../api/strapi';

function HookWrapper({
  render
}) {
  return render(history(), loadGlossary(), loadSocialMedia(), loadHeaderImage(), useLocale());
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}

function loadSocialMedia() {
  const { data } = useSelector(state => state.global)
  return (data && data.settings && data.settings.socialLinks) || []
}

function loadHeaderImage() {
  const { data } = useSelector(state => state.global)
  const media = data && data.settings && normalizeMedia(data.settings.headerImage)
  return (media && media.file_url) || ''
}

function history() {
  const history = useHistory();
  return history;
}

class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.textInput = null;
    this.setTextInputRef = element => {
      this.textInput = element;
    };

    this.focusTextInput = () => {
      // Focus the text input using the raw DOM API
      if (this.textInput) this.textInput.focus();
    };

    this.state = {
      search: false,
      menu: false,
      value:''
    }
    this._setLang = this._setLang.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this._toggleMenu = this._toggleMenu.bind(this);
  }

  _showSearch = () => {
    this.setState({
      search: true,
    });
  };

  _hideSearch = () => {
    this.setState({
      search: false,
      value: '',
    });
  };

   _setLang = (history, lg) => {
    const newLocale = lg.toLowerCase()

    // Deliberate Cookies write: remembers the choice so a bare "/" visit
    // later lands on the right locale (see App.js's root redirect).
    Cookies.set("locale", lg);

    const { pathname, search } = history.location
    const newPath = pathname.replace(/^\/(en|id)(?=\/|$)/, `/${newLocale}`)
    history.push(newPath + search)
   }

  _toggleMenu = () => {
    const { menu } = this.state;

    if (menu) {
      this.setState({
        menu: false
      })
    } else {
      this.setState({
        menu: true
      })
    }
  }

  _renderHeaderMobile = (history, locale) => {
    const { menu, search } = this.state;
    const { theme } = this.props;

    let en_active = '';
    let id_active = '';

    if(locale === 'en' ){
      en_active = style[`language-active`];
      id_active = '' ;
    }else{
       en_active = '';
       id_active = style[`language-active`];
    }

    return (
      <div className={`${style[`header__container--mobile`]}`}>
        {
          menu && (
            <div className={`${style[`header__container--language`]}`}>
              <div className={`${style.language__link} ${en_active}`} onClick={()=>this._setLang(history, 'EN')}>
                <span>EN</span>
              </div>
              <div className={style.language__separator} />
              <div className={`${style.language__link} ${id_active}`} onClick={()=>this._setLang(history, 'ID')}>
                <span>ID</span>
              </div>
            </div>
          )
        }
        <div
          className={`${style[`header__mobile--icon`]}`}
          onClick={() => this._toggleMenu()}
        >
          {
            menu ? (
              <Icon
                type={theme !== "white" ? "close" : "closewhite"}
                className={style.header__icon}
              />
            ) : (
              <Icon
                type={theme !== "white" ? "hamburger" : "hamburgerwhite"}
                className={style.header__icon}
              />
            )
          }
        </div>
      </div>
    );
  }
  handleChange(event) {
    this.setState({value: event.target.value});
  }
  handleSubmit(event, history, locale) {
    event.preventDefault();
    const value = this.state.value;
    if(value !==''){
      history.push(`/${locale}/search?keyword=${value}`)
    }

    this.setState({value: ''});
  }

  _renderSearch = (history, glossary, locale) => {
    const { search, value } = this.state;
    setTimeout(() => {
      this.focusTextInput();
    }, 500);

    return (
      <div className={`${style[`header__container--search`]} ${search ? style[`header__container--search-open`] : null}`}>
        <form onSubmit={(event)=>this.handleSubmit(event,history,locale)}>
          <div className={style.header__search}>
            <input ref={this.setTextInputRef} value={value} placeholder = { glossary.search || 'Search'} className = { `${style[`header__search--input`]}` } onChange = { this.handleChange } />
            {/* Showcase purpose only, use button for the real practice */}
            <Link to={`/${locale}/search?keyword=${value}`} className={`${style[`header__search--button`]}`}>
              <Icon type="searchwhite" className={style.header__icon} />
            </Link>
            {/* <button className={`${style[`header__search--button`]}`}>
              <Icon type="searchwhite" className={style.header__icon} />
            </button> */}
          </div>
        </form>
        <div className={`${style[`header__container--close`]}`} onClick={() => this._hideSearch()}>
          <Icon type="closewhite" className={`${style[`header__icon--close`]}`} />
        </div>
      </div>
    )
  }

  _renderMenu = (glossary, history, locale) => {
    const { search } = this.state;
    const { theme } = this.props;

    let en_active = '';
    let id_active = '';

    if(locale === 'en' ){
      en_active = style[`language-active`];
      id_active = '' ;
    }else{
       en_active = '';
       id_active = style[`language-active`];
    }

    return (
      <div className={`${style[`header__container--link`]} ${search ? style[`header__container--link-hide`] : null}`}>
        <div className={`${style[`header__container--inner`]}`}>
          <Link to={`/${locale}/about`} className={`${style.header__link} ${theme !== "white" ? style[`header__link-black`] : null}`}>
            <span> { glossary.about || 'About'}</span>
          </Link>
          <Link  to={`/${locale}/projects`} className={`${style.header__link} ${theme !== "white" ? style[`header__link-black`] : null}`}>
            <span>{ glossary.projects || 'Projects'}</span>
          </Link>
          <Link to={`/${locale}/services`} className={`${style.header__link} ${theme !== "white" ? style[`header__link-black`] : null}`}>
            <span>{ glossary.services || 'Services'}</span>
          </Link>
          <Link to={`/${locale}/our-client`} className={`${style.header__link} ${theme !== "white" ? style[`header__link-black`] : null}`}>
            <span>{ glossary.clients || 'Our Clients'}</span>
          </Link>
          <Link to={`/${locale}/contact`} className={`${style.header__link} ${theme !== "white" ? style[`header__link-black`] : null}`}>
            <span>{ glossary.contact || 'Contact'}</span>
          </Link>
          <div className={`${style[`header__container--language`]}`} >
            <div className={`${style.language__link} ${en_active}`} onClick={()=>this._setLang(history, 'EN')}>
              <span>EN</span>
            </div>
            <div className={style.language__separator} />
            <div className={`${style.language__link} ${id_active}`}  onClick={()=>this._setLang(history, 'ID')}>
              <span>ID</span>
            </div>
          </div>
        </div>
        <div className={`${style[`header__container--icon`]}`} onClick={() => this._showSearch()}>
          <Icon type={theme !== "white" ? "search" : "searchwhite"} className={style.header__icon} />
        </div>
      </div>
    )
  }

  render() {
    const { theme } = this.props;

    return (
      <HookWrapper render={ (history, glossary, socialmedia, headerImage, locale) =>
      <>
        <div className={`${style.header} ${theme !== "white" ? style[`header-transparent`] : null}`}>
          <div className={style.header__container}>
            <Link to={`/${locale}`} className={`${style[`header__container--logo`]}`}>
              <img src={headerImage !=''? headerImage : '/assets/main-logo.svg'}  alt="main-logo" className={`${style[`header--logo`]}`} />
            </Link>
            {this._renderMenu(glossary, history, locale)}
            {this._renderSearch(history, glossary, locale)}
            {this._renderHeaderMobile(history, locale)}
          </div>
        </div>
        <Menu visible={this.state.menu} glossary={glossary} history={history} locale={locale} socialmedia={socialmedia} that={this}/>
      </>
      }/>
    );
  }
}

export default Header;

Header.defaultProps = {
  theme: 'white'
}
